import { mapActions, mapGetters, mapState } from 'vuex'
import cloneDeep from 'lodash.clonedeep'

export default {
  props: {
    profile: {
      type: Object,
      required: true
    },
    inputTitle: {
      type: String,
      required: true
    },
    dispatch: Boolean,
  },
  computed: {
    ...mapState('auth', ['isUpdateProfilePending']),
    ...mapGetters('i18n', ['tc'])
  },
  watch: {
    dispatch(val) {
      if (val) {
        this.$refs.form.form.submit()
      }
    },
    isUpdateProfilePending(val) {
      if (!val) {
        this.$emit('done')
      }
    }
  },
  mounted() {
    if (!this.$refs.form) {
      throw new Error('No form: update your code to add a <form ref="form">')
    }
    if (this.localProfile) {
      Object.keys(this.localProfile).forEach((key) => {
        this.localProfile[key] = cloneDeep(this.profile[key])
      })
    }
  },
  methods: {
    ...mapActions('auth', ['updateProfile']),
    getValidationForField(validation, field = '') {
      return this.tc(`profile.validations.${validation}`).replace('{0}', this.tc(`profile.formFields.${field}`))
    }
  }
}
